import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import { copyTextToClipboard } from "../../../../AdminApi/commFunc";
import {
  decryptPW,
  GetMakeHideStringByLength,
  GetSplitMyPartyAccInfo,
} from "../../../../Api/ApiCommon";
import {
  GetShareInfoSetByShareInfoID,
  GetSubscriptionSetData,
} from "../../../../Api/ServiceDatas";
import LineBtn from "../../../Button/LineBtn";
import Blank from "../../../DefaultStyles/Blank";
import Flex from "../../../DefaultStyles/Flex";
import LineBox from "../../../DefaultStyles/LineBox";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import VerticalTable from "../../../Table/VerticalTable";
import LoginCheckBtn from "./PartyDetailShareInfo/LoginCheckBtn";
import PartyMailModal from "./PartyDetailShareInfo/PartyMailModal";
import { getNowUseSystemLoginCheckWeb } from "../../../../Api/ApiLoginCheckWeb";
import { useParams } from "react-router-dom";
import {
  getShareDefData,
  GetSubscriptionSetData_V3,
} from "../../../../ApiTS/ServiceDatasTS_V3";
import ChangePartyAccinfoSetModal from "./ChangePartyAccinfoSetModal/ChangePartyAccinfoSetModal";
import { AxiosRequestConfig } from "axios";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";

interface IShareInfoData {
  SHARINFO_ID?: number;
  INQ_LDRPF?: string | null;
  INQ_LDRID?: number;
  INQ_LDRPW?: number;
  INQ_ADLTPW?: number;
  INQ_PROFNM?: number;
  CHK_LDRID?: number;
  CHK_MBRID?: number;
  CHK_FORM?: number;
  CHK_LDRPDAY?: number;
  PRTEM_ACCT?: number;
}

interface PartyDetailShareInfoProps {
  data?: {
    shareInfo?: string;
    password?: string;
    passwordLog?: string;
    email?: string;
    owner?: string;
    ownerName?: string;
    ownerNickname?: string;
    shareid?: string;
    servsubsid?: number;
    state?: number;
    partyid?: string;
    idtype?: string;
    UserExtra?: [
      {
        type: number;
        value: string;
      }
    ];
  };
  status?: number;
  subsId: number;
  fetchData: (params: AxiosRequestConfig) => Promise<void>;
}

export default function PartyDetailShareInfo({
  data,
  status,
  subsId,
  fetchData,
}: PartyDetailShareInfoProps) {
  const { partyId } = useParams();
  const auth = useRecoilValue(authType);

  const [showPw, setShowPw] = useState(false);
  const [mailModal, setMailModal] = useState(false);
  const [AccSetModal, setAccSetModal] = useState(false);
  const [useLoginCheck, setUseLoginCheck] = useState<any>(false);

  const subsData = GetSubscriptionSetData_V3(subsId);
  // const shareInfoData: IShareInfoData | any = subsData
  //   ? GetShareInfoSetByShareInfoID(subsData?.SHARINFO_ID)[0]
  //   : [];

  const shareDefData = getShareDefData(subsData?.SHARDEF_ID!, 1);

  const isSystemParty = data?.owner === "1";

  const accountInfo = GetSplitMyPartyAccInfo(
    shareDefData?.SHARDEF_TYP === "open_id" ||
      shareDefData?.SHARDEF_TYP === "invite_extra" ||
      shareDefData?.SHARDEF_TYP === "invite_lkdextra"
      ? data?.shareid ?? ""
      : data?.shareInfo ?? ""
  );

  const account =
    accountInfo?.id && accountInfo?.id !== ""
      ? accountInfo?.id
      : GetSplitMyPartyAccInfo(data?.shareid)?.id ?? "";

  const passwordInfo = decryptPW(
    String(data?.password ?? ""),
    String(data?.owner ?? "")
  );

  const pw = passwordInfo.pw === undefined ? passwordInfo : passwordInfo.pw;

  console.log(pw);

  const partyAddress = data?.UserExtra?.find((d) => d?.type === 1);

  const shareInfoHeader = [
    "로그인 수단",
    "공유 ID",
    "공유 비밀번호",
    "성인 비밀번호",
    shareDefData?.SHARDEF_TYP === "open_lkid" || isSystemParty
      ? "메일함"
      : null,
    shareDefData?.LDR_PDAY !== 0 ? "네이버 결제일" : null,
    subsData?.SVC_ID === 600 ? "파티주소" : null,
  ];

  const shareInfoBody = [
    [
      `${
        accountInfo?.idType !== ""
          ? accountInfo?.idType
          : data?.idtype !== ""
          ? data?.idtype
          : "-"
      }`,
    ],
    [
      `${account}`,
      <LineBtn
        icon="content_copy"
        sPadding="0 7px"
        btnClickEvent={() =>
          copyTextToClipboard(
            account?.replace(/(\s*)/g, ""),
            "공유 ID가 복사되었습니다."
          )
        }
        disabled={!data}
      />,
    ],
    [
      `${showPw ? pw : GetMakeHideStringByLength(pw) ?? "-"}`,
      <>
        {pw && (
          <Flex gapSize={8}>
            <>
              <LineBtn
                btnText={showPw ? "숨기기" : "보기"}
                btnClickEvent={() => setShowPw(!showPw)}
                disabled={!data}
              />

              <LineBtn
                icon="content_copy"
                sPadding="0 7px"
                btnClickEvent={() =>
                  copyTextToClipboard(
                    pw?.replace(/(\s*)/g, ""),
                    "공유 비밀번호가 복사되었습니다."
                  )
                }
                disabled={!data}
              />
            </>
          </Flex>
        )}
      </>,
    ],
    [
      ` ${
        showPw
          ? passwordInfo?.adltPw && passwordInfo?.adltPw !== ""
            ? passwordInfo?.adltPw
            : "-"
          : GetMakeHideStringByLength(passwordInfo?.adltPw!) ?? "-"
      }`,
      <>
        {passwordInfo?.adltPw && (
          <LineBtn
            btnText={showPw ? "숨기기" : "보기"}
            btnClickEvent={() => setShowPw(!showPw)}
            disabled={!data}
          />
        )}
      </>,
    ],
    shareDefData?.SHARDEF_TYP === "open_lkid" || isSystemParty
      ? [
          shareDefData?.SHARDEF_TYP === "open_lkid" || isSystemParty
            ? `${
                GetSplitMyPartyAccInfo(
                  isSystemParty ? data?.shareid : data?.shareInfo
                )?.id ?? "-"
              }`
            : null,
          <>
            {(shareDefData?.SHARDEF_TYP === "open_lkid" || isSystemParty) && (
              <LineBtn
                btnText="보기"
                btnClickEvent={() => {
                  setMailModal(true);
                }}
                disabled={!data}
              />
            )}
          </>,
        ]
      : null,
    shareDefData?.LDR_PDAY !== 0
      ? [`${accountInfo?.ldrPday !== 0 ? `${accountInfo?.ldrPday}일` : "-"}`]
      : null,

    subsData?.SVC_ID === 600
      ? [
          `${partyAddress?.value}`,
          <LineBtn
            icon="content_copy"
            sPadding="0 7px"
            btnClickEvent={() =>
              copyTextToClipboard(
                partyAddress?.value!,
                "파티주소가 복사되었습니다."
              )
            }
            disabled={!data}
          />,
        ]
      : null,
  ];

  useEffect(() => {
    if (subsId) {
      const getIsUseLoginCheck = async () => {
        const check = await getNowUseSystemLoginCheckWeb(subsId);

        setUseLoginCheck(check ? true : false);
      };

      getIsUseLoginCheck();
    }
  }, [subsId]);

  return (
    <LineBox boxHeight="100%">
      <>
        <SpaceBetween>
          <TitleWithLine title="공유 정보" />

          <Flex gapSize={10}>
            <>
              {data?.passwordLog && (
                <LastUpdateText>
                  {dayjs(data?.passwordLog)?.format("YYYY-MM-DD HH:mm:ss")}{" "}
                  마지막 변경
                </LastUpdateText>
              )}
            </>
            <LineBtn
              btnText={"설정"}
              btnColor="white"
              disabled={!auth?.partyInfo}
              btnClickEvent={() => {
                return setAccSetModal(true);
              }}
            />
            <>
              {useLoginCheck && (
                <LoginCheckBtn
                  accountInfo={{
                    id: account,
                    agList: accountInfo?.agList,
                    idType:
                      accountInfo?.idType !== ""
                        ? accountInfo?.idType
                        : data?.idtype !== ""
                        ? data?.idtype
                        : "",
                    ldrPday: accountInfo?.ldrPday,
                    profileName: accountInfo?.profileName,
                  }}
                  passwordInfo={passwordInfo}
                  subsId={subsId}
                  partyId={Number(partyId ?? 0)}
                />
              )}
            </>
          </Flex>
        </SpaceBetween>

        <Blank blankHeight={24} />

        <VerticalTable
          tableHeaderData={shareInfoHeader}
          tableFlexBodyData={status === 200 ? shareInfoBody : [""]}
        />

        {mailModal && (
          <PartyMailModal
            closeEvent={() => setMailModal(false)}
            mailId={
              shareDefData?.SHARDEF_TYP === "open_lkid"
                ? data?.shareid?.split("/")[0]
                : data?.email ?? data?.shareid?.split("/")[0] ?? ""
            }
            subsId={subsId}
            type="db"
          />
        )}

        {/* 공유 계정 수정  모달 */}
        {AccSetModal && (
          <ChangePartyAccinfoSetModal
            cancelEvent={() => setAccSetModal(false)}
            secretOffEvent={() => {
              setAccSetModal(false);
            }}
            isSecret={data?.ownerName!}
            partyId={data?.partyid!}
            shareid={account}
            password={pw}
            idtype={
              accountInfo?.idType !== ""
                ? accountInfo?.idType
                : data?.idtype !== ""
                ? data?.idtype
                : ""
            }
            adltPw={passwordInfo.adltPw}
            owner={data?.owner!}
            updateEvent={() =>
              fetchData({
                method: "get",
                url: `party/${data?.partyid}`,
              })
            }
          />
        )}
      </>
    </LineBox>
  );
}

const LastUpdateText = styled.span`
  font-size: 13px;
  line-height: 19.5px;
  text-align: right;
  color: #858c97;
`;
